import { generatePath } from 'react-router-dom';
import { axiosInstance, axiosSecretAuthInstance } from './axiosInstance';
import { getApiUrl } from './helpers';
import { ApiRoutes, Ga4CampaignInfoApiResponse, Ga4CampaignUrlApiResponse, Ga4ConnectionResponse } from 'types';

export async function fetchGa4Url(campaignId: number) {
  const path = generatePath(ApiRoutes.GetCampaignUrl, { campaignId: String(campaignId) });
  const { data } = await axiosInstance.get<Ga4CampaignUrlApiResponse>(getApiUrl({ path }));
  return data;
}

export async function fetchGa4Info(campaignId: number, secret: string) {
  const path = generatePath(ApiRoutes.GetGa4Info, { campaignId: String(campaignId) });
  const { data } = await axiosSecretAuthInstance(secret).get<Ga4CampaignInfoApiResponse>(getApiUrl({ path }));
  return data;
}

export async function updateGa4PropertyId(campaignId: number, ga4PropertyId: string, secret: string) {
  const path = generatePath(ApiRoutes.SetGa4PropertyId, { campaignId: String(campaignId) });
  const axios = axiosSecretAuthInstance(secret);
  const { data } = await axios.put(getApiUrl({ path }), { ga4PropertyId });
  return data;
}

export async function updateUserGa4PropertyId(defaultGa4PropertyId: string) {
  const path = ApiRoutes.SetUserGa4PropertyId;
  const { data } = await axiosInstance.put(getApiUrl({ path }), { defaultGa4PropertyId });
  return data;
}

export async function checkGa4connection(campaignId: number, sendSuccessEmail: boolean) {
  const path = generatePath(ApiRoutes.CheckGa4Connection, { campaignId: String(campaignId) });
  const { data } = await axiosSecretAuthInstance().post<Ga4ConnectionResponse>(getApiUrl({ path }), {
    sendSuccessEmail,
  });
  return data;
}

export async function checkUserGa4PropertyId(defaultGa4PropertyId: string) {
  const path = ApiRoutes.CheckUserGa4PropertyId;
  const { data } = await axiosInstance.post<Ga4ConnectionResponse>(getApiUrl({ path }), { defaultGa4PropertyId });
  return data;
}
